import scrollElementTo from '~/utils/animation/scrollElementTo';
import slideshow from './slideshow';

/**
 * Заголовочная область страницы.
 */
function main(): void
{
	initGoDownButton();
	loadHeader();
	slideshow();
}

/**
 * Инициализация кнопки прокрутки с первого экрана на последующий.
 */
function initGoDownButton(): void
{
	const button = document.querySelector( 'body>header>div.subtitle>button.go-down' );
	
	if ( !button )
	{
		return;
	}
	
	button.addEventListener(
		'click',
		() =>
		{
			scrollElementTo( window, window.innerHeight, 1000 );
		},
	);
}

/**
 * Загружает картинки в шапке, чтобы показать пользователю.
 */
function loadHeader(): void
{
	const header = document.querySelector( 'html > body > header' );
	const loader = document.querySelector( 'html > body > div.loader' );

	if ( !header || !loader )
	{
		return;
	}

	loader.classList.add( 'show' );

	const images : Array<Element> = Array.from( header.querySelectorAll( 'div.slideshow > ul.slides > li > picture > img' ) );
	let imagesCount : number = 0;
	let loadedImagesCount : number = 0;

	images.forEach(
		( it : Element, i : number ) =>
		{
			const image : HTMLImageElement = new Image();
			const src = it.getAttribute( 'src' );

			if ( !src )
			{
				return;
			}

			image.src = src;
			imagesCount++;

			image.addEventListener(
				'load',
				() =>
				{
					loadedImagesCount++;

					if ( i > 0 && loadedImagesCount === imagesCount )
					{
						document.body.classList.add( 'loaded' );

						const loadTimeout = setTimeout( () => {
							document.body.classList.add( 'scrollable' );
							clearTimeout( loadTimeout );
						}, 3000 );

						const popup = document.querySelector( 'body>div.popup' );

						if ( !popup )
						{
							return;
						}

						const timeout = setTimeout( () => {
							popup.classList.remove( 'hide' );
							clearTimeout( timeout );
						}, 5000 );
					}
				}
			)
		}
	);
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Index/Header/index.ts